// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"HistoryList_tableContainer__1T1N1"};